import MerchantMenuUploadDesktop from './MerchantMenuUploadDesktop'
import MerchantMenuUploadMobile from './MerchantMenuUploadMobile'

export default function MerchantMenuUploadPage() {
  return (
    <>
      <MerchantMenuUploadMobile />
      <MerchantMenuUploadDesktop />
    </>
  )
}
